var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4C0 28.9933 2.96 32 6.6 32H25.4067C29.0467 31.9933 32 29.04 32.0067 25.4V6.6C32.0067 3.00667 29.0467 0 25.4067 0H6.6C3 0 0 2.96 0 6.6V25.4067V25.4Z",
    fill: "#1C2D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.37333 4 4 9.37333 4 16C4 22.6267 9.37333 28 16 28C22.6267 28 28 22.6267 28 16C28 9.37333 22.6267 4 16 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 6.39998C21.2931 6.39998 25.5997 10.7066 25.5997 16C25.5997 21.2933 21.2931 25.6 15.9997 25.6C10.7064 25.6 6.39974 21.2933 6.39974 16C6.39974 10.7066 10.7064 6.39998 15.9997 6.39998ZM15.9997 5.56665C10.2331 5.56665 5.56641 10.24 5.56641 16C5.56641 21.76 10.2397 26.4333 15.9997 26.4333C21.7597 26.4333 26.4331 21.76 26.4331 16C26.4331 10.24 21.7597 5.56665 15.9997 5.56665Z",
    fill: "#1C2D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9859 10.0666C14.6193 9.85328 15.2926 9.73328 15.9993 9.73328C19.4593 9.73328 22.2593 12.5399 22.2593 15.9933C22.2593 19.4466 19.4526 22.2533 15.9993 22.2533C12.5459 22.2533 9.73926 19.4466 9.73926 15.9933C9.73926 15.2799 9.85926 14.5999 10.0726 13.9599L16.0059 15.9866L13.9859 10.0599V10.0666Z",
    fill: "#1C2D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 26.8199L17.8066 24.3733C21.1666 23.6533 23.8333 20.8933 24.4333 17.5066L26.9 17.9466C26.1133 22.3933 22.7466 25.8733 18.3333 26.8266V26.8199Z",
    fill: "#1C2D4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuview);
export default __webpack_public_path__ + "static/media/CUVIEW.4870a527ec280b384e905af55adb46d4.svg";
export { ForwardRef as ReactComponent };